<!-- Compact tiles: eight categories used to take more than a full phone screen. -->
<section class="bg-yellow-50 py-8 lg:py-14 px-3">
    <h2 class="text-center text-2xl lg:text-4xl font-bold text-gray-900 pb-5 lg:pb-8">Категории</h2>
    <div class="max-w-6xl mx-auto grid grid-cols-4 lg:grid-cols-8 gap-2 lg:gap-4">
        @for (category of productCategories; track category.link.route) {
            <a [routerLink]="[category.link.route]"
               class="flex flex-col items-center rounded-lg border border-yellow-100 bg-white p-1.5 lg:p-3 text-center shadow-sm hover:shadow-md transition">
                <app-image [class]="'block w-full aspect-square object-contain'"
                           [width]="160" [height]="160"
                           [src]="category.image" [alt]="label(category.link.text)"></app-image>
                <span class="pt-1 text-[11px] leading-tight lg:text-sm font-medium text-gray-900">{{ label(category.link.text) }}</span>
            </a>
        }
    </div>
</section>
